/**
 * SECTION - FOOTER - LISTENERS
 */

setupEventListenersForFooter();

// Creates the event listeners
function setupEventListenersForFooter() {
  // On clicking on a fold-out menu in the footer
  document.querySelectorAll('.linklist-item--expandable > .linklist__link').forEach((element) => {
    element.addEventListener('click', openFooterNextDropdown);
  });
}

/**
 * SECTION - FOOTER - GENERAL
 */

// Displays or hides a fold-out menu from the footer
function openFooterNextDropdown() {
  var menuItem = event.target.closest('.linklist-item'),
      menuItemSiblings = getSiblings(menuItem);

  event.preventDefault();
  menuItem.classList.toggle('linklist-item--active');
  menuItem.setAttribute('aria-expanded', menuItem.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
  menuItemSiblings.forEach((element) => {
    var subMenuItemActive = element.querySelector('.linklist-item--active');
    
    element.setAttribute('aria-expanded', 'false');
    element.classList.remove('linklist-item--active');
    
    if (subMenuItemActive !== null) {
      subMenuItemActive.setAttribute('aria-expanded', 'false');
      subMenuItemActive.classList.remove('linklist-item--active');
    }
  });
  
  return false;
}